import { makeAutoObservable } from 'mobx'
import moment from 'moment'
import SalesTrackerStore from './index'
import { getWeekMonday } from './getWeekMonday.function'

class AvDateStore {
  minDate = null
  maxDate = null

  constructor() {
    makeAutoObservable(this)
  }

  determineMinimumAvDate = minBackdate => {
    minBackdate = minBackdate && typeof minBackdate === 'string' ? new Date(minBackdate) : minBackdate
    minBackdate = minBackdate && minBackdate instanceof Date ? minBackdate : false

    const setMaxDate = () => {
      if (minBackdate) {
        this.maxDate = new Date()
        return
      }

      this.maxDate = moment(this.minDate).add(6, 'day').toDate()
      const maxDateTime = this.maxDate.getTime(),
        currDateTime = new Date().getTime()

      if (maxDateTime > currDateTime) this.maxDate = new Date()
    }

    if (SalesTrackerStore.Policy.isNew()) {
      // as early as Monday of this week.
      this.minDate = getWeekMonday(minBackdate ? minBackdate : new Date())
    } else if (minBackdate) {
      let avDate = SalesTrackerStore.Policy.get('av_date')
      avDate = avDate && typeof avDate === 'string' ? new Date(avDate) : avDate
      avDate = avDate && avDate instanceof Date ? avDate : false

      if (minBackdate && avDate) {
        // as early as Monday of the week of the indicated date.
        this.minDate = getWeekMonday(
          minBackdate.getTime() < avDate?.getTime() ? minBackdate : SalesTrackerStore.Policy.get('av_date')
        )
      } else {
        // as early as Monday of the week of the indicated date.
        this.minDate = getWeekMonday(SalesTrackerStore.Policy.get('av_date'))
      }

      return setMaxDate()
    } else {
      // as early as Monday of the week of the indicated date.
      this.minDate = getWeekMonday(SalesTrackerStore.Policy.get('av_date'))
    }

    setMaxDate()
  }
}

export default new AvDateStore()
